import axios from "axios";
import { loginreq, req, reqPost } from "./axiosFun";


// 添加自习室 
export const addRoomApi = params => {
    return req("post", "/app-yijiu-backstage/addAdminStudyRoom", params);
};
// 修改自习室 
export const modifyRoomApi = params => {
    return req("post", "/app-yijiu-backstage/upAdminStudyRoom", params);
};
// 删除自习室 
export const deleteRoomApi = params => {
    return req("post", "/app-yijiu-backstage/deleteAdminStudyRoom", params);
};
// 自习室列表 
export const roomListApi = params => {
    return req("post", "/app-yijiu-backstage/getAdminStudyRoomList", params);
};

// 添加字典 
export const addDictApi = params => {
    return req("post", "/app-yijiu-backstage/addAdminDropdownConfig", params);
};
// 字典列表 
export const dictListApi = params => {
    return req("get", "/app-yijiu-backstage/getAdminDropdownConfigList", params);
};
// 子级列表 
export const childListApi = params => {
    return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getAdminDropdownConfigInfo?token=${localStorage.getItem("logintoken")}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 编辑字典 
export const editDictApi = params => {
    return req("post", "/app-yijiu-backstage/upAdminDropdownConfig", params);
};

//删除字典 
export const delDictApi = params => {

    return axios
    .get(
      "http://118.195.249.109:446/app-yijiu-backstage/deleteAdminDropdownConfig?token="+localStorage.getItem("logintoken")+'&id='+params.id,
      params
    )
    .then(res => res.data);
}; 


// WEBPACK FOOTER //
// ./src/api/room_admin.js